// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"84a9d829","456":"be81e869","715":"30bad497","724":"67175e67"}[chunkId] + ".chunk.js";
};